import React from 'react'
import { Box, Typography } from '@mui/material'
import { Navbar } from '../component/shared/Navbar'
import { Helmet } from 'react-helmet-async'
import { AdminMenu } from '../component/admin/AdminMenu'
import { AdminXsMenu } from '../component/admin/AdminXsMenu'
import { ClaimReviewTable } from '../component/staff-benefit-review/ClaimReviewTable'

export const StaffBenefitReviewPanelScreen = () => {
  return (
    <>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>Staff Benefit Claims</title>
      </Helmet>

      <Navbar />
      <Box display={{ xs: 'block', md: 'flex' }}>
        <AdminMenu />
        <Box
          overflow='hidden'
          boxSizing='border-box'
          width='100%'
          sx={{ p: { xs: 1 } }}
          mb={{ xs: 2, md: 10 }}
        >
          <Box display='flex' my={3} justifyContent='space-between'>
            <Typography variant='h1'>Staff Benefit Claims</Typography>
            <AdminXsMenu />
          </Box>
          <ClaimReviewTable />
        </Box>
      </Box>
    </>
  )
}
